import React from 'react';
import PropTypes from 'prop-types';
import Base from '../Base';
import Icon from "components/common/MaterialIcon";
import {InputNumber, Input} from 'antd';

@autobind
/**
 *
 */
export default class Number extends Base {
  static propTypes = {
    ...Base.propTypes,
    value: PropTypes.string,
  };

  /**
   *
   * @return {XML}
   * @protected
   */
  get _component() {
    const {rest} = this.props;
    return <Input
      prefix={<Icon name="alphabetical"/>}
      type="number"
      dir="auto"
      {...rest}
    />;
    // return <InputNumber/>;
  }
}
